<template>
  <e-btn-circle-status v-if="s === helper.STATUS_PENDENTE" status="warning" class="sm m-r-xs" />
  <e-btn-circle-status v-else-if="s === helper.STATUS_PAGO" status="positive" class="sm m-r-xs" />
  <e-btn-circle-status v-else-if="s === helper.STATUS_CANCELADO" status="negative" class="sm m-r-xs" />
  <i v-else></i>
</template>

<script>
import {EBtnCircleStatus} from 'uloc-vue-plugin-erp'
import * as Status from '../../../../domain/leiloes/helpers/PagamentoStatus'
export default {
  name: 'StatusPagamentoLoteIcon',
  props: ['status'],
  components: {EBtnCircleStatus},
  computed: {
    helper () {
      return Status
    },
    s () {
      return parseFloat(this.status)
    }
  }
}
</script>
